import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import Button from '@/common/components/Button/Button';
import Heading from '@/common/components/Heading/Heading';
import { ASET_PAGE, SPECTRUM_PAGE } from '@/common/constants/pages';
import URLBuilder from '@/common/network/URLBuilder';
import { SpectrumQueryKey } from '@/spectrum/constants/query';
import styles from './SuccessTaskMessage.module.less';
function SuccessTaskMessage(props) {
    const { page, spectrumProduct } = props;
    const path = useMemo(() => {
        let queryKey = SpectrumQueryKey.Product;
        const entityId = spectrumProduct.productId;
        if (!spectrumProduct.demo) {
            queryKey = SpectrumQueryKey.Node;
        }
        const params = {
            ...URLBuilder.params(),
            [queryKey]: entityId,
        };
        return `${page}${URLBuilder.buildQueryString(params)}`;
    }, [spectrumProduct]);
    const onNavigate = useCallback(() => {
        window.location.href = path;
    }, [path]);
    function renderTitle() {
        let title = '';
        switch (page) {
            case ASET_PAGE:
                title = 'Dead Zones Demo';
                break;
            case SPECTRUM_PAGE:
            default:
                title = 'Light-Spectrum Demo';
                break;
        }
        return title ? `${title} - ` : '';
    }
    return (_jsxs("div", { children: [_jsxs(Heading, { appearance: "h4", className: styles.title, children: [_jsx("span", { children: renderTitle() }), _jsx("span", { children: "Conversion complete" })] }), _jsxs("div", { className: styles.description, children: [_jsx("span", { children: "Filename: " }), _jsx("span", { children: spectrumProduct.title })] }), _jsx(Button, { color: "accent", onClick: onNavigate, children: "View" })] }));
}
export default memo(SuccessTaskMessage);
